var _g, _path, _path2, _rect, _rect2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5PicCohort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1406_60810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 20.2C3 19.0799 3 18.5198 3.21799 18.092C3.40973 17.7157 3.71569 17.4097 4.09202 17.218C4.51984 17 5.0799 17 6.2 17H38.8C39.9201 17 40.4802 17 40.908 17.218C41.2843 17.4097 41.5903 17.7157 41.782 18.092C42 18.5198 42 19.0799 42 20.2V43H3V20.2Z",
    fill: "#0AB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 43.5H42.5V43V20.2V20.1786C42.5 19.6367 42.5 19.1996 42.4711 18.8457C42.4413 18.4813 42.3784 18.1612 42.2275 17.865C41.9878 17.3946 41.6054 17.0122 41.135 16.7725L40.9082 17.2176L41.135 16.7725C40.8388 16.6216 40.5187 16.5587 40.1543 16.5289C39.8004 16.5 39.3633 16.5 38.8214 16.5L38.8 16.5H6.2L6.1786 16.5C5.6367 16.5 5.19963 16.5 4.84569 16.5289C4.48126 16.5587 4.16117 16.6216 3.86502 16.7725C3.39462 17.0122 3.01217 17.3946 2.77248 17.865C2.62159 18.1612 2.55868 18.4813 2.52891 18.8457C2.49999 19.1996 2.49999 19.6367 2.5 20.1786L2.5 20.2V43V43.5H3H42Z",
    stroke: "#956004"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 28.8324C8.63896 29.4297 17.3455 26.065 14.3896 24.1205C12.4727 22.8595 11.1948 31.8189 12.4727 36",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4545 27C21.8182 27.5833 22.4545 32.8333 21.1818 34M18 31.0833C19.2727 30.5 23.7273 31.0833 25 30.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 43,
    width: 45,
    height: 3,
    rx: 1,
    fill: "#C78605"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 41,
    width: 6,
    height: 2,
    rx: 1,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 41.6C6 41.0399 6 40.7599 6.10899 40.546C6.20487 40.3578 6.35785 40.2049 6.54601 40.109C6.75992 40 7.03995 40 7.6 40H12.4C12.9601 40 13.2401 40 13.454 40.109C13.6422 40.2049 13.7951 40.3578 13.891 40.546C14 40.7599 14 41.0399 14 41.6V43H6V41.6Z",
    fill: "#627484"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4247 27.1792C30.2856 27.7766 30.5958 22.9979 34.0131 24.1926C37.4304 25.3872 34.2724 34.3472 31.4247 34.9445C28.5769 35.5419 30.2856 31.0841 34.0131 32.6478C36.8609 33.8425 35.9811 35.5418 38 34.4398",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1406_60810",
    x: -2,
    y: 12,
    width: 49,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1406_60810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1406_60810",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5PicCohort);
export default __webpack_public_path__ + "static/media/5pic_cohort.7da0fb89.svg";
export { ForwardRef as ReactComponent };